import storage from '../lib/clients/local-storage-wrapper';
import { type FlagName, FLAG_NAMES } from './registry';

export type Overrides = Partial<Record<FlagName, boolean>>;

const STORAGE_KEY = 'ff-overrides';

export const loadOverrides = (): Overrides => {
  const raw = storage.getText(STORAGE_KEY);
  if (!raw) {
    return {};
  }
  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    return FLAG_NAMES.reduce<Overrides>((acc, name) => {
      if (typeof parsed[name] === 'boolean') {
        acc[name] = parsed[name] as boolean;
      }
      return acc;
    }, {});
  } catch {
    return {};
  }
};

export const saveOverrides = (overrides: Overrides): void => {
  storage.set(STORAGE_KEY, JSON.stringify(overrides));
};
